import { Record } from "immutable";

export type EmbeddedAnswerMark = {
  teacherMark?: number | undefined;
  questionPartId: string;
};

export type AssigneeQuestionStatType = {
  mark?: number;
  marksTotal?: number;
  flagged?: boolean;
  selfMark?: number;
  studyTime?: number;
  answerTimeCreated?: string;
  teacherMark?: number;
  embeddedAnswerMarks?: EmbeddedAnswerMark[];
  confidence?: number;
};

export const defaultAssigneeQuestionStat: AssigneeQuestionStatType = {
  mark: undefined,
  marksTotal: undefined,
  flagged: undefined,
  selfMark: undefined,
  studyTime: undefined,
  answerTimeCreated: undefined,
  teacherMark: undefined,
  embeddedAnswerMarks: undefined,
  confidence: undefined
};

export default class AssigneeQuestionStat extends Record(
  defaultAssigneeQuestionStat
) {}
